import type {
  OccurrenceReferenceEnum,
  SalesAssociateTrackingPositioningRule,
  SalesAssociateTrackingTreeEnum,
} from '../../../__generated__/schema-types'

export enum List {
  Waiting = 'WAITING',
  InService = 'IN_SERVICE',
  OutOfStore = 'OUT_OF_STORE',
}

export type Relation = {
  salesAssociateId: string
  results?: string[]
  lostReasons?: string[]
}

type Icon = {
  id?: string | null
} | null

export type ServiceInfo = {
  name: string | null | undefined
  icon?: Icon
}

export type ListItemService = {
  startDate: Date
  motives?: Occurrence[]
  relations?: Relation[]
  icon?: Icon
}

export type WaitingListItem<MovementFlowStep, SalesAssociate> = {
  kind: List.Waiting
  salesAssociate: SalesAssociate
  service?: ListItemService
  unfinishedMovements: MovementFlowStep[]
  positionReferenceTime: Date | null
  displaydServiceInfo?: ServiceInfo
}

export type InServiceListItem<MovementFlowStep, SalesAssociate> = {
  kind: List.InService
  salesAssociate: WaitingListItem<
    MovementFlowStep,
    SalesAssociate
  >['salesAssociate']
  service?: WaitingListItem<MovementFlowStep, SalesAssociate>['service']
  unfinishedMovements: MovementFlowStep[]
  positionReferenceTime: WaitingListItem<
    MovementFlowStep,
    SalesAssociate
  >['positionReferenceTime']
  displaydServiceInfo?: ServiceInfo
}

export type OutOfStoreItem<MovementFlowStep, SalesAssociate> = {
  kind: List.OutOfStore
  salesAssociate: SalesAssociate
  unfinishedMovements: MovementFlowStep[]
  positionReferenceTime: Date | null
  lastMovement: MovementFlowStep | null
}

export type DragData<ItemType> = {
  queueItem: ItemType
  element: HTMLElement
  index: number
}

export type OccurrencesRecord = {
  color?: string | null | undefined
  icon?: Icon
  id?: string | null
  name?: string | null
  positioningRule?: SalesAssociateTrackingPositioningRule | null
  reference?: OccurrenceReferenceEnum
}

export type Occurrence = {
  treeType: SalesAssociateTrackingTreeEnum
  record: OccurrencesRecord
  children: Occurrence[]
}

export type OccurrencesTrees = Record<
  SalesAssociateTrackingTreeEnum,
  Occurrence
>

export enum ModalContentTemplate {
  Occurrences = 'OCCURRENCES',
  MultipleAssistances = 'MULTIPLE_ASSISTANCES',
  SalesAssociates = 'SALES_ASSOCIATES',
}

export type MultipleAssistancesData = {
  active: boolean
  assistancesCount: number
  currentAssistance: number
  occurrences: Occurrence[]
}
